<template>
    <main>
        <slot name="label">
            <p class="mb-2"><strong>Bagikan ke:</strong></p>
        </slot>
        <div class="flex items-center">
            <share-network
                v-for="(item, i) in types"
                :key="i"
                :network="item.name"
                :url="link"
                :title="name"
                :description="description"
            >
                <div class="flex items-center py-2 px-3 rounded mr-4" :style="item.style">
                    <strong class="block text-white">
                        <small>
                            {{ capitalize(item.name) }}
                        </small>
                    </strong>
                </div>
            </share-network>
        </div>
    </main>
</template>
<script>
import { ShareNetwork } from 'vue-social-sharing';
export default {
    props: {
        types: {
            type: Array,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: () => ''
        }
    },
    components: {
        ShareNetwork
    }   
}
</script>